export function hasPaymentContent(state) {
  const channelsDealInfo = _.get(state, 'payments.channelsDealInfo');
  const videosDealInfo = _.get(state, 'payments.videosDealInfo');

  return !_.isEmpty(channelsDealInfo) || !_.isEmpty(videosDealInfo);
}

export function isPayed(entity) {
  return Boolean(_.get(entity, 'dgsInfo'));
}




// WEBPACK FOOTER //
// ./src/shared/selectors/payments.js